import { render } from "./PhaseTimerBox.vue?vue&type=template&id=6ec65df8&scoped=true"
import script from "./PhaseTimerBox.vue?vue&type=script&lang=js"
export * from "./PhaseTimerBox.vue?vue&type=script&lang=js"

import "./PhaseTimerBox.vue?vue&type=style&index=0&id=6ec65df8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec65df8"]])

export default __exports__